import moment from "moment";

/**
 * Changes the body attribute
 */
const changeHTMLAttribute = (attribute: string, value: string): boolean => {
  if (document.documentElement) {
    document.documentElement.setAttribute(attribute, value);
  }
  return true;
};
const convertDate = (isFrom = false, range = 1) => {
  const date = new Date();
  const fromDate = moment
    .utc(date)
    .subtract(range, "day")
    .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
  const toDate = moment
    .utc(date)
    .add(range, "day")
    .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
  return isFrom ? fromDate : toDate;
};

export { changeHTMLAttribute, convertDate };
